import CarruselHorizontal from "components/Carrusel/CarruselHorizontal";
import React from "react";
import profesoresData from "../data/profesores.json";
import ProfesorCard from "components/ProfesorCard";
import Carrusel from "components/Carrusel/Carrusel";

function Nosotros() {
  const objetivos = [
    {
      icon: "fa-solid fa-shapes",
      objetivo:
        "Implementar procesos de formación contextualizados que permitan un aprendizaje significativo y humanizante.",
    },
    {
      icon: "fa-solid fa-graduation-cap",
      objetivo:
        "Incrementar las competencias de los estudiantes en lengua extranjera de acuerdo al marco común europeo de referencia internacional.",
    },
    {
      icon: "fa-solid fa-chalkboard-user",
      objetivo:
        "Maximizar los niveles de satisfacción de la comunidad, mediante la implementación de estrategias de aprendizaje que den respuesta a las necesidades académicas y laborales.",
    },
    {
      icon: "fa-solid fa-award",
      objetivo:
        "Incentivar la cultura de calidad, mejoramiento continuo y valoración de los procesos de aprendizaje. ",
    },
    {
      icon: "fa-solid fa-handshake",
      objetivo:
        "Establecer convenios y alianzas estratégicas con el sector académico (colegios, centros de formación, universidades) y empresarial (sector público y privado) para trabajar en procesos de formación en lengua inglesa pertinentes a las necesidades e interés de nuestros colaboradores internos y externos.",
    },
  ];
  const staff = [
    {
      nombre: "Carlos Santacruz",
      img: "https://brightonenglishcenter.edu.co/img/Carlos.jpg",
      cargo: "Director General",
    },
    {
      nombre: "Patricia Rosales",
      img: "https://brightonenglishcenter.edu.co/img/Patricia.jpg",
      cargo: "Directora Administrativa",
    },
    {
      nombre: "Diana Zamudio",
      img: "https://brightonenglishcenter.edu.co/img/Diana.jpg",
      cargo: "Coordinadora Academica",
    },
    {
      nombre: "Paola Narvaez",
      img: "https://brightonenglishcenter.edu.co/img/Paola-N.jpg",
      cargo: "Secretaria Académica",
    },
    {
      nombre: "Martha Rosales",
      img: "https://brightonenglishcenter.edu.co/img/Martha.jpg",
      cargo: "Exámenes de Certificación",
    },
    {
      nombre: "Angela Castro",
      img: "https://brightonenglishcenter.edu.co/img/Angela.jpg",
      cargo: "Asesora Comercial",
    },
    {
      nombre: "Paola Yamá",
      img: "https://brightonenglishcenter.edu.co/img/Paola_Yama.jpg",
      cargo: "Diseñadora Grafica",
    },
    {
      nombre: "Julian Enriquez",
      img: "https://brightonenglishcenter.edu.co/img/Julian.webp",
      cargo: "Area de Sistemas",
    },
  ];
  const itemsProfes = profesoresData.map((profes, index) => (
    <ProfesorCard key={index} profesor={profes} />
  ));
  const CardStaff = ({ nombre, cargo, img }) => {
    return (
      <div className="w-full h-[400px] bg-white shadow-[-10px_10px_0px_0px_#0d2334] flex flex-col gap-5 justify-center items-center rounded-lg rounded-tl-none">
        <div className="w-[200px] h-[200px] rounded-full overflow-hidden">
          <img
            src={img}
            alt={`${nombre} ${cargo}`}
            width={200}
            loading="lazy"
            className="object-cover w-full h-full object-center"
          />
        </div>
        <p className="text-3xl text-primario">{nombre}</p>
        <p className="text-xl font-bold font-Bebas tracking-wider text-blue-6">
          {cargo}
        </p>
      </div>
    );
  };
  const CardObjetivos = ({ icon, objetivo }) => {
    return (
      <div className="relative w-[420px] h-[400px] shadow-[-10px_10px_0px_0px_#6798c0] bgpria bg-blue-100 hyphens-none rounded-lg rounded-tl-none text-center overflow-hidden text-primario">
        <p className="absolute text-xl hyphens-none p-10 transform top-1/2 -translate-y-1/2 z-20">
          {objetivo}
        </p>
        <i
          class={icon}
          style={{
            fontSize: "250px",
            color: "#bfdbfe",
            position: "absolute",
            bottom: "5px",
            right: "5px",
            rotate: "10deg",
            zIndex: "10",
          }}
        ></i>
      </div>
    );
  };
  return (
    <>
      <section className="">
        <div className="flex flex-col bg-primario ">
          <div className="lg:m-32 xl:m-40 space-y-10 flex flex-col justify-end items-center h-[30vh]">
            <h1 className="lg:text-8xl xl:text-9xl font-Bebas font-bold text-center text-secundario tracking-wider">
              Acerca de nosotros
            </h1>
          </div>
          <div className="w-full h-[100vh] overflow-hidden">
            <img
              src="https://brightonenglishcenter.edu.co/img/brighton_1.jpg"
              alt="Brighton Centro de Formacion en Ingles"
              width={1920}
              height={1080}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="lg:p-32 xl:p-40">
            <p className="hyphens-none text-white text-2xl text-center w-3/4 mx-auto">
              Desde nuestros inicios en el año 2011, en{" "}
              <strong>Brighton Centro de Inglés</strong> nos hemos dedicado a
              elevar el nivel de inglés de nuestros estudiantes. Fundada con la
              visión de ofrecer una educación de calidad, nuestro centro de
              ingles ha evolucionado para convertirse en un referente en la
              preparación para exámenes como IELTS, TOEFL, APTIS y OOPT.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div className="p-40 flex flex-row items-start justify-evenly text-primario">
          <h2 className="text-7xl font-Bebas font-bold tracking-wide w-fit ">
            Misión
          </h2>
          <p className="text-2xl w-1/2 hyphens-none">
            Brighton es un Centro de formación en ingles de alto nivel, bajo los
            estándares del Marco Común Europeo que brinda educación
            personalizada en ambientes pedagógicos contextualizados,
            humanizantes y de calidad dirigida a una comunidad que desea ser más
            competitiva en el ámbito laboral, académico y social con visión
            internacional.
          </p>
        </div>
        <div className="p-40 flex flex-row items-start justify-evenly text-primario bg-secundario">
          <h2 className="text-7xl font-Bebas font-bold tracking-wide w-fit ">
            Visión
          </h2>
          <p className="text-2xl w-1/2 hyphens-none">
            Brighton, en el 2030 será considerado uno de los mejores centros de
            formación en inglés reconocido por sus altos estándares de calidad,
            personal profesional y humano, cobertura regional, nacional e
            internacional; con un portafolio de servicios dirigido al público
            actual y nuevo que identifiquen la importancia de aprender una
            segunda lengua, contribuyendo a que los egresados puedan construir
            un mejor futuro académico, laboral, cultural y social con proyección
            internacional.
          </p>
        </div>
        <div className="w-full h-screen">
          <img
            src="https://brightonenglishcenter.edu.co/img/calidad.jpg"
            alt="Brighton se compromete a formar estudiantes con altos estándares
              de calidad de acuerdo con el marco de referencia institucional."
            className="w-full h-full object-cover object-top"
          />
        </div>
        {/* <div className="w-1/2 rounded-30 rounded-tl-none overflow-hidden">
          <img
            src="https://brightonenglishcenter.edu.co/img/web4.jpg"
            alt="Brighton es un Centro de formación en ingles de alto nivel, bajo los estándares del Marco Común Europeo que brinda educación personalizada en ambientes pedagógicos contextualizados, humanizantes y de calidad."
            className="w-full h-full object-cover"
          />
        </div> */}
      </section>
      <section>
        <div className="p-40 flex flex-row justify-evenly">
          <h2 className="text-7xl font-Bebas font-bold tracking-wide text-primario w-fit">
            Compromiso con la Calidad
          </h2>
          <p className="w-1/2 hyphens-none text-2xl">
            Brighton se compromete a formar estudiantes con altos estándares de
            calidad de acuerdo con el marco de referencia internacional mediante
            una metodología dinámica, en contexto y personalizada que promueva
            el desarrollo profesional, con visión competitiva en ámbitos
            regionales, nacionales e internacionales, a través del mejoramiento
            continuo de nuestros procesos.
          </p>
        </div>
        <div className=" bg-primario">
          <div className="p-40">
            <h3 className="text-7xl font-Bebas font-bold tracking-wide text-secundario w-full text-center ">
              Objetivos de Calidad
            </h3>
          </div>
          <CarruselHorizontal>
            {objetivos.map((value, index) => (
              <CardObjetivos
                key={index}
                icon={value.icon}
                objetivo={value.objetivo}
              />
            ))}
          </CarruselHorizontal>
        </div>
      </section>
      <section className="">
        <div className="p-40 bg-secundario space-y-20">
          <h2 className="text-7xl font-Bebas font-bold text-primario">
            Nuestros Docentes
          </h2>
          <Carrusel items={itemsProfes} />
        </div>
      </section>
      <section>
        <div className="p-40 bg-blue-50 space-y-20">
          <h2 className="text-7xl font-Bebas font-bold text-primario">
            Nuestro Equipo
          </h2>
          <div className="grid grid-cols-3 gap-5 w-3/4 mx-auto">
            {staff.map((value, index) => (
              <CardStaff
                key={index}
                img={value.img}
                nombre={value.nombre}
                cargo={value.cargo}
              />
            ))}
            {/* <div>
              BRIGHTONIO
            </div> */}
          </div>
          {/* <Carrusel items={itemsProfes} /> */}
        </div>
      </section>
    </>
  );
}

export default Nosotros;
